import React, { useEffect, useState } from "react";
// import "./AdminUserList.css";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { screenConfig } from "../../config/screenConfig";
import AdminUserList from "./AdminUserList";
import AdminUserCreation from "./AdminUserCreation";

const AdminUserComponent: React.FC = () => {
  const currentConfigurationMenu = useSelector(
    (state: RootState) => state.screen.adminUserScreen
  );

  const renderAdminUserCreen = () => {
    if (currentConfigurationMenu == screenConfig.adminUserListScreen) {
      return <AdminUserList />;
    } else if (currentConfigurationMenu == screenConfig.adminUserCreateScreen) {
      return <AdminUserCreation />;
    }
  };

  return <>{renderAdminUserCreen()}</>;
};

export default AdminUserComponent;
